import dayjs from '~/lib/dayjs';

export const generateDateOptions = (startDate = dayjs().startOf('month'), endDate = dayjs().startOf('month').add(2, 'year')) => {
  const options = [];

  let d = dayjs(startDate).startOf('month');
  while (d.isBefore(endDate)) {
    options.push({ value: d.format('YYYY-MM-DD'), label: d.format('MMMM YYYY') });
    d = d.add(1, 'month');
  }

  return options;
};
